/* eslint-disable no-nested-ternary */
import { Progress } from '@/components/ui/progress';

import { UploadProgress } from '../../matter-details/documents/types';

interface UploadProgressItemProps {
  progress: UploadProgress;
}

export const UploadProgressItem = ({ progress }: UploadProgressItemProps) => {
  return (
    <div className="space-y-0.5 mb-1">
      <div className="flex justify-between text-[11px]">
        <span className="truncate max-w-[200px]">{progress.fileName}</span>
        <span className="ml-1 text-[10px] whitespace-nowrap">
          {progress.status === 'completed'
            ? 'Completed'
            : progress.status === 'error'
              ? 'Failed'
              : `${Math.round(progress.progress)}%`}
        </span>
      </div>
      <Progress value={progress.progress} className="h-0.5" />
    </div>
  );
};

export default UploadProgressItem;
